export const state = () => ({
  startingPoint: '',
  parkingProvider: null,
  parkingService: null,
  merchantContent: null,
});

export const mutations = {
  setParkingProvider(state, value) {
    state.parkingProvider = value;
  },
  setParkingService(state, value) {
    state.parkingService = value;
  },
  setMerchantContent(state, value) {
    state.merchantContent = value;
  },
};
export const getters = {
  getParkingProvider: (state) => state.parkingProvider,
  getParkingService: (state) => state.parkingService,
  getMerchantContent: (state) => state.merchantContent,
};
export const actions = {
  async getMerchantContent({ commit }, { merchantId, locationId, languageId, parkType }) {
    if (parkType) {
      const result = await this.app.$pbx.getMerchantContent(merchantId, locationId, languageId, parkType);
      commit('setMerchantContent', result);
    } else {
      commit('setMerchantContent', null);
    }
  },
};
